import React from 'react';
import _ from 'lodash';

import {
  ATTACH_DOCUMENT_TYPE_COMPANY,
  EXISTANCE_EXCLUSION_FLAG,
} from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';
import { Description } from '../../components/Description';
import AttachDocument from '../../components/forms/AttachDocument';
import {
  INSURANCE_STATUS,
  getInsuranceStatus,
  isConstructionIndustryPermissionStatus,
  isOtherSubscriptionStatus,
  isAcceptanceForeignWorkersStatus,
  partnerCompanyFindStatus,
  filterComboBoxHealthInsuranceTypeWhenExist,
  filterComboBoxHealthInsuranceTypeWhenExclusion,
  filterComboBoxPensionInsuranceTypeWhenExist,
  filterComboBoxPensionInsuranceTypeWhenExclusion,
} from '../../utilities/companySafetyUtil';
import {
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
  TextInput,
  FormElementContainer,
  FormElementContainerItem,
} from '../CommonFormComponents';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';
import { FormSelect } from '../FormSelect';
import { FormInput } from '../FormInput';
import { AdditionalInfoAboutOthers } from '../../components/AdditionalInfoAboutOthers';
import { InsuranceDocumentMyNumberCardWarning } from '../InsuranceDocumentAttention';
import { CompanyInsuranceManual } from '../CompanyInsuranceManual';
import CompanyLicenseInformation from '../CompanyLicenseInformation';
import { CompanyOtherIndustryLicenseInformation } from '../CompanyOtherIndustryLicenseInformation';
import { OldAttachmentPermission } from '../OldAttachmentPermission';

/**
 * 協力会社情報確認 画面  支店労務安全項目 タブ
 * 画面遷移
 *  - 協力会社管理者でログイン > 会社情報確認 > 支店労務安全項目
 */
export const PartnerCompanyBranchSafetyForm = ({
  values,
  messages = {},
  checkboxList,
  comboboxList,
  events,
  readOnly = false,
  companyDocuments,
  documentCodes,
  partnerCompanyBranch,
  bureaux,
  attentionBox = null,
  eventCompanyBranchPermissionCommon,
  selectedCompanyId,
}) => {
  const findStatusFn = (type, targetValue) => {
    return partnerCompanyFindStatus(type, targetValue, checkboxList);
  };

  //健康保険で加入フラグの値によって保険種類に表示する絞り込みを行う必要がある
  let healthInsuranceTypesComboBoxList = _.cloneDeep(
    comboboxList.health_insurance_types
  );

  //加入状況が「有」
  if (
    values.company_branch_insurance.health_insurance_flag ===
    EXISTANCE_EXCLUSION_FLAG.EXIST.ID
  ) {
    healthInsuranceTypesComboBoxList = filterComboBoxHealthInsuranceTypeWhenExist(
      healthInsuranceTypesComboBoxList
    );
  }
  //加入状況が「適用除外」
  if (
    values.company_branch_insurance.health_insurance_flag ===
    EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
  ) {
    healthInsuranceTypesComboBoxList = filterComboBoxHealthInsuranceTypeWhenExclusion(
      healthInsuranceTypesComboBoxList,
      values.company_branch_insurance.health_insurance_reason_exclusion
    );
  }

  //年金保険で加入フラグの値によって保険種類に表示する絞り込みを行う必要がある
  let pensionInsuranceTypesComboBoxList = _.cloneDeep(
    comboboxList.pension_insurance_types
  );
  //年金保険で加入フラグの値によって社会保険名称に表示する絞り込みを行う必要がある
  //加入状況が「有」
  if (
    values.company_branch_insurance.pension_flag ===
    EXISTANCE_EXCLUSION_FLAG.EXIST.ID
  ) {
    pensionInsuranceTypesComboBoxList = filterComboBoxPensionInsuranceTypeWhenExist(
      pensionInsuranceTypesComboBoxList
    );
  }
  //加入状況が「適用除外」
  if (
    values.company_branch_insurance.pension_flag ===
    EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
  ) {
    pensionInsuranceTypesComboBoxList = filterComboBoxPensionInsuranceTypeWhenExclusion(
      pensionInsuranceTypesComboBoxList
    );
  }

  /**
   * valuesからcheckboxListのkey(PRESENCEなど)を取得
   * keyを元に安全書類項目の切り替えを判断するオブジェクトを作成
   * そのオブジェクトを元に、安全書類項目、非表示を制御する
   */

  // 健康保険加入状況
  const selectedHealthInsurance = findStatusFn(
    INSURANCE_STATUS,
    values.company_branch_insurance.health_insurance_flag
  );

  // 年金保険加入状況
  const selectedPensionInsurance = findStatusFn(
    INSURANCE_STATUS,
    values.company_branch_insurance.pension_flag
  );
  // 雇用保険加入状況
  const selectedEmploymentInsurance = findStatusFn(
    INSURANCE_STATUS,
    values.company_branch_insurance.employment_insurance_flag
  );

  /**
   * 健康、年金、雇用保険の安全書類項目の表示、非表示制御用オブジェクト
   */
  const insuranceStatus = getInsuranceStatus({
    selectedHealthInsurance,
    selectedPensionInsurance,
    selectedEmploymentInsurance,
  });

  // 建設業許可有無の安全書類項目の表示、非表示制御用
  const constructionIndustryPermissionStatus = isConstructionIndustryPermissionStatus(
    values.company_detail.construction_industry_permission_flag
  );

  // その他退職金共済の安全書類項目の表示、非表示制御用
  const OtherSubscriptionStatus = isOtherSubscriptionStatus(
    values.company_branch_insurance.other_subscription_flag
  );

  // 外国人就労者情報
  const AcceptanceForeignWorkersStatus = isAcceptanceForeignWorkersStatus(
    values.company_detail.acceptance_foreign_workers_flag
  );

  /**
   * 健康保険_理由を表示するべきかどうかを判定する
   * @param {object} healthInsuranceFlag 加入状況のステータス
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceUninsuredReason = healthInsuranceFlag => {
    return healthInsuranceFlag === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID;
  };

  /**
   * 健康保険_保険種類を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceType = () => {
    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };

  /**
   * 健康保険_保険者名称を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceNameInsurer = () => {
    if (
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        '５人未満個人事業所' &&
      values.company_branch_insurance.health_insurance_type === '国民健康保険'
    ) {
      return false;
    }

    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };

  /**
   * 健康保険_事業所整理記号を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceOfficeSymbol = () => {
    if (
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        '５人未満個人事業所' &&
      values.company_branch_insurance.health_insurance_type === '国民健康保険'
    ) {
      return false;
    }
    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };

  /**
   * 健康保険_事業所番号を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceOfficeNumber = () => {
    if (
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        '５人未満個人事業所' &&
      values.company_branch_insurance.health_insurance_type === '国民健康保険'
    ) {
      return false;
    }
    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };
  /**
   * 健康保険_添付書類を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showAttachDocumentTypeCompanyHealthInsurance = () => {
    if (values.company_branch_insurance.health_insurance_flag !== null) {
      if (values.company_branch_insurance.health_insurance_flag !== '') {
        return true;
      }
    }
    return false;
  };
  /**
   * 年金保険_加入状況を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showPensionInsuranceType = () => {
    if (insuranceStatus.pensionPresence || insuranceStatus.pensionExclusion) {
      return true;
    }
    return false;
  };
  /**
   * 年金保険_理由を表示するべきかどうかを判定する
   * @param {object} pentionInsuranceFlag 加入状況のステータス
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showPensionUninsuredReason = pentionInsuranceFlag => {
    return pentionInsuranceFlag === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID;
  };

  /**
   * 年金保険_添付書類を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showAttachDocumentTypeCompanyPensionInsurance = () => {
    if (values.company_branch_insurance.pension_flag !== null) {
      if (values.company_branch_insurance.pension_flag !== '') {
        return true;
      }
    }
    return false;
  };
  /**
   * 雇用保険_添付書類を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showAttachDocumentTypeCompanyEmploymentInsurance = () => {
    if (values.company_branch_insurance.employment_insurance_flag !== null) {
      if (values.company_branch_insurance.employment_insurance_flag !== '') {
        return true;
      }
    }
    return false;
  };

  /**
   * 理由を表示するべきかどうかを判定する
   * @param {object} employmentInsuranceFlag 加入状況のステータス
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showEmploymentInsuranceUninsuredReason = employmentInsuranceFlag => {
    return employmentInsuranceFlag === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID;
  };

  const renderHealthInsuranceTypeFormSelect = () => {
    if (readOnly) {
      return (
        <span>{values.company_branch_insurance.health_insurance_type}</span>
      );
    }
    // 既存データ対応
    if (
      values.company_branch_insurance.health_insurance_type === 'その他'
      // ||
      // values.company_branch_insurance.health_insurance_reason_exclusion ===
      //   'その他'
    ) {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='health_insurance_type'
              value={
                values.company_branch_insurance.health_insurance_type !== null
                  ? values.company_branch_insurance.health_insurance_type
                  : ''
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option value=''>選択してください</option>
              <option
                key='0'
                value='その他'
                disabled
                selected
                style={{ display: 'none' }}
              >
                その他
              </option>
              {_.map(healthInsuranceTypesComboBoxList, (item, index) => (
                <option key={index} value={item.name}>
                  {item.name}
                </option>
              ))}
            </FormSelect>
          </FormElementContainerItem>
          {values.company_branch_insurance.health_insurance_type ===
            'その他' && (
            <FormElementContainerItem>
              <FormInput
                name='health_insurance_type_other'
                type='text'
                value={
                  values.company_branch_insurance.health_insurance_type_other
                }
                messages={messages}
                disabled={readOnly}
                maxLength={255}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={e => events.setFormValue('company_branch_insurance', e)}
                data-testid={'health_insurance_type_other'}
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      );
    }

    // 加入状況が「適用除外」、適用除外理由が「けんぽ適用除外承認済」の場合、保険種類に国民健康保険組合を表示する
    if (
      values.company_branch_insurance.health_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        'けんぽ適用除外承認済'
    ) {
      return (
        <span data-testid='health_insurance_type_text'>
          {values.company_branch_insurance.health_insurance_type}
        </span>
      );
    }
    return (
      <FormElementContainer>
        <FormElementContainerItem>
          <FormSelect
            name='health_insurance_type'
            value={
              values.company_branch_insurance.health_insurance_type !== null
                ? values.company_branch_insurance.health_insurance_type
                : ''
            }
            onChange={e => events.setFormValue('company_branch_insurance', e)}
            onBlur={e => events.setFormValue('company_branch_insurance', e)}
          >
            <option value=''>選択してください</option>
            {_.map(healthInsuranceTypesComboBoxList, (item, index) => (
              <option key={index} value={item.name}>
                {item.name}
              </option>
            ))}
          </FormSelect>
        </FormElementContainerItem>
      </FormElementContainer>
    );
  };

  const renderHealthInsuranceReasonExclusionForm = () => {
    if (readOnly) {
      return (
        <span>
          {values.company_branch_insurance.health_insurance_reason_exclusion}
        </span>
      );
    }
    // 既存データ対応
    if (
      values.company_branch_insurance.health_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        'その他'
    ) {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='health_insurance_reason_exclusion'
              value={
                values.company_branch_insurance
                  .health_insurance_reason_exclusion
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option value=''>選択してください</option>
              {_.map(
                comboboxList.health_insurance_exclusions,
                (item, index) => (
                  <option key={index} value={item.tekiyoujogai_reason}>
                    {item.tekiyoujogai_reason}
                  </option>
                )
              )}
              <option
                key='0'
                value='その他'
                disabled
                selected
                style={{ display: 'none' }}
              >
                その他
              </option>
            </FormSelect>
          </FormElementContainerItem>
          {values.company_branch_insurance.health_insurance_reason_exclusion ===
            'その他' && (
            <FormElementContainerItem>
              <FormInput
                name='health_insurance_reason_exclusion_other'
                type='text'
                value={
                  values.company_branch_insurance
                    .health_insurance_reason_exclusion_other
                }
                messages={messages}
                disabled={readOnly}
                maxLength={255}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={e => events.setFormValue('company_branch_insurance', e)}
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      );
    }
    return (
      <FormElementContainer>
        <FormElementContainerItem>
          <FormSelect
            name='health_insurance_reason_exclusion'
            value={
              values.company_branch_insurance
                .health_insurance_reason_exclusion !== null
                ? values.company_branch_insurance
                    .health_insurance_reason_exclusion
                : ''
            }
            onChange={e => events.setFormValue('company_branch_insurance', e)}
            onBlur={e => events.setFormValue('company_branch_insurance', e)}
          >
            <option value=''>選択してください</option>
            {_.map(comboboxList.health_insurance_exclusions, (item, index) => (
              <option key={index} value={item.tekiyoujogai_reason}>
                {item.tekiyoujogai_reason}
              </option>
            ))}
          </FormSelect>
        </FormElementContainerItem>
      </FormElementContainer>
    );
  };

  const renderPensionReasonExclusionFormSelect = () => {
    if (readOnly) {
      return (
        <span>{values.company_branch_insurance.pension_reason_exclusion}</span>
      );
    }
    // 既存データ対応
    if (
      values.company_branch_insurance.pension_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      values.company_branch_insurance.pension_reason_exclusion === 'その他'
    ) {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='pension_reason_exclusion'
              value={
                values.company_branch_insurance.pension_reason_exclusion !==
                null
                  ? values.company_branch_insurance.pension_reason_exclusion
                  : ''
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option value=''>選択してください</option>
              <option
                key='0'
                value='その他'
                disabled
                selected
                style={{ display: 'none' }}
              >
                その他
              </option>
              <option value='５人未満個人事業所'>５人未満個人事業所</option>
            </FormSelect>
          </FormElementContainerItem>
          {values.company_branch_insurance.pension_reason_exclusion ===
            'その他' && (
            <FormElementContainerItem>
              <FormInput
                name='pension_reason_exclusion_other'
                type='text'
                value={
                  values.company_branch_insurance.pension_reason_exclusion_other
                }
                messages={messages}
                disabled={readOnly}
                maxLength={255}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={e => events.setFormValue('company_branch_insurance', e)}
                data-testid='pension_reason_exclusion_other'
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      );
    }
    if (
      values.company_branch_insurance.pension_flag ===
      EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='pension_reason_exclusion'
              value={
                values.company_branch_insurance.pension_reason_exclusion !==
                null
                  ? values.company_branch_insurance.pension_reason_exclusion
                  : ''
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option value=''>選択してください</option>
              {_.map(
                comboboxList.pension_insurance_exclusions,
                (option, index) => {
                  return (
                    <option value={option['tekiyoujogai_reason']} key={index}>
                      {option['tekiyoujogai_reason']}
                    </option>
                  );
                }
              )}
            </FormSelect>
          </FormElementContainerItem>
        </FormElementContainer>
      );
    }
  };

  const renderPensionTypeFormSelectWhenExist = () => {
    if (readOnly) {
      return <span>{values.company_branch_insurance.pension_type}</span>;
    }
    // 既存データ対応
    if (values.company_branch_insurance.pension_type === 'その他') {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='pension_type'
              value={
                values.company_branch_insurance.pension_type !== null
                  ? values.company_branch_insurance.pension_type
                  : ''
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option
                key='0'
                value='その他'
                disabled
                selected
                style={{ display: 'none' }}
              >
                その他
              </option>
              {_.map(pensionInsuranceTypesComboBoxList, (item, index) => (
                <option key={index} value={item.name}>
                  {item.name}
                </option>
              ))}
            </FormSelect>
          </FormElementContainerItem>
          {values.company_branch_insurance.pension_type === 'その他' && (
            <FormElementContainerItem>
              <FormInput
                name='pension_type_other'
                type='text'
                value={values.company_branch_insurance.pension_type_other}
                messages={messages}
                disabled={readOnly}
                maxLength={255}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={e => events.setFormValue('company_branch_insurance', e)}
                data-testid={'pension_type_other'}
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      );
    }
    return (
      <span data-testid='pension_type_exist'>
        {values.company_branch_insurance.pension_type}
      </span>
    );
  };
  const renderPensionTypeFormSelectWhenExclusion = () => {
    return (
      <span data-testid='pension_type_exclusion'>
        {values.company_branch_insurance.pension_type}
      </span>
    );
  };

  const renderEmploymentInsuranceReasonExclusionFormSelect = () => {
    if (readOnly) {
      return (
        <span>
          {
            values.company_branch_insurance
              .employment_insurance_reason_exclusion
          }
        </span>
      );
    }
    // 既存データ対応
    if (
      values.company_branch_insurance.employment_insurance_flag ===
        EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      values.company_branch_insurance.employment_insurance_reason_exclusion ===
        'その他'
    ) {
      return (
        <FormElementContainer>
          <FormElementContainerItem>
            <FormSelect
              name='employment_insurance_reason_exclusion'
              value={
                values.company_branch_insurance
                  .employment_insurance_reason_exclusion
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={e => events.setFormValue('company_branch_insurance', e)}
            >
              <option value=''>選択してください</option>
              <option
                key='0'
                value='その他'
                disabled
                selected
                style={{ display: 'none' }}
              >
                その他
              </option>
              {_.map(
                comboboxList.employment_insurance_exclusions,
                (option, index) => {
                  return (
                    <option value={option['tekiyoujogai_reason']} key={index}>
                      {option['tekiyoujogai_reason']}
                    </option>
                  );
                }
              )}
            </FormSelect>
          </FormElementContainerItem>
          {values.company_branch_insurance
            .employment_insurance_reason_exclusion === 'その他' && (
            <FormElementContainerItem>
              <FormInput
                name='employment_insurance_reason_exclusion_other'
                type='text'
                value={
                  values.company_branch_insurance
                    .employment_insurance_reason_exclusion_other
                }
                messages={messages}
                disabled={readOnly}
                maxLength={255}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={e => events.setFormValue('company_branch_insurance', e)}
                data-testid='employment_insurance_reason_exclusion_other'
              />
            </FormElementContainerItem>
          )}
        </FormElementContainer>
      );
    }
    return (
      <FormElementContainer>
        <FormElementContainerItem>
          <FormSelect
            name='employment_insurance_reason_exclusion'
            value={
              values.company_branch_insurance
                .employment_insurance_reason_exclusion
            }
            onChange={e => events.setFormValue('company_branch_insurance', e)}
            onBlur={e => events.setFormValue('company_branch_insurance', e)}
          >
            <option value=''>選択してください</option>
            {_.map(
              comboboxList.employment_insurance_exclusions,
              (option, index) => {
                return (
                  <option value={option['tekiyoujogai_reason']} key={index}>
                    {option['tekiyoujogai_reason']}
                  </option>
                );
              }
            )}
          </FormSelect>
        </FormElementContainerItem>
      </FormElementContainer>
    );
  };

  // 加入状況が無(未加入)の場合、未加入でも良いと証明する書類を期待するメッセージを表示
  const renderDocumentationMessage = name => {
    return (
      !readOnly &&
      values[`company_branch_insurance`][name] ===
        EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID &&
      messageUtility.getMessage('I-000-135')
    );
  };

  const renderCompanyConstructionIndustry = () => {
    return (
      <React.Fragment>
        <CompanyLicenseInformation
          events={events}
          values={values}
          readOnly={readOnly}
          bureaux={bureaux}
          checkboxList={checkboxList}
          industryDefault={comboboxList.construct_permit_industry_types}
          companyDocuments={companyDocuments}
          documentCodes={documentCodes}
          eventCompanyBranchPermissionCommon={
            eventCompanyBranchPermissionCommon
          }
          selectedCompanyId={selectedCompanyId}
        />
      </React.Fragment>
    );
  };

  const renderCompanyOtherIndustryLicense = () => {
    return (
      <CompanyOtherIndustryLicenseInformation
        events={events}
        values={values}
        checkboxList={checkboxList}
        readOnly={readOnly}
        documentCodes={documentCodes}
        constructionIndustries={comboboxList.construct_permit_industry_types}
        selectedCompanyId={selectedCompanyId}
        onDownloadFile={eventCompanyBranchPermissionCommon.download}
      />
    );
  };

  return (
    <div className='contruction-detail-view__main contruction-detail-view__main--fixed'>
      <FormList>
        {attentionBox && attentionBox}
        {!readOnly && (
          <div className='form-list-default__ExceptionalItems'>
            <InsuranceDocumentMyNumberCardWarning />
          </div>
        )}
        <FormListSubHeader title='基本情報' noMarginTop />
        <FormListItem label='支店名'>
          <FormElement>
            <TextInput
              type='text'
              name='name'
              maxLength={255}
              disabled={true}
              value={partnerCompanyBranch.name}
              onChange={e => events.setFormValue('partner_company_branch', e)}
              onBlur={
                events.validate
                  ? () => events.validate('partner_company_branch')
                  : null
              }
            />
          </FormElement>
        </FormListItem>
        {renderCompanyConstructionIndustry()}
        {renderCompanyOtherIndustryLicense()}
        <OldAttachmentPermission
          companyDocuments={values.old_company_permission_documents}
          documentCodes={documentCodes}
          events={events}
          readOnly={readOnly}
          hasSecurityPermission={false}
        />
        <CompanyInsuranceManual />
        <FormListSubHeader title='健康保険情報' />
        {!readOnly && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              お手元に健康保険の加入内容証明書・社会保険納入証明書・領収済証などをご用意頂きご登録頂くとスムーズです。
            </Description>
          </div>
        )}
        <FormListItem
          label='加入状況'
          safetyDocItem={true}
          data-testid='health_insurance_flag'
        >
          <FormElement
            info={renderDocumentationMessage('health_insurance_flag')}
          >
            <div className='form-list-radio'>
              {_.map(checkboxList.insurance_statuses, (answer, index) =>
                readOnly ? (
                  values.company_branch_insurance.health_insurance_flag ===
                    answer.value && <span key={index}>{answer.name}</span>
                ) : (
                  <div className='form-list-radio__item' key={index}>
                    <label className='radio'>
                      <input
                        type='radio'
                        id={`form-radio-health_insurance_flag-${answer.id}`}
                        value={answer.value}
                        name='health_insurance_flag'
                        checked={
                          values.company_branch_insurance
                            .health_insurance_flag === answer.value
                        }
                        onChange={e =>
                          events.setFormValue('company_branch_insurance', e)
                        }
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>{answer.name}</span>
                    </label>
                  </div>
                )
              )}
            </div>
          </FormElement>
        </FormListItem>
        {showHealthInsuranceUninsuredReason(
          values.company_branch_insurance.health_insurance_flag
        ) && (
          <FormListItem
            label='理由'
            data-testid='health_insurance_uninsured_reason'
          >
            <FormElement>
              <TextInput
                type='text'
                name='health_insurance_uninsured_reason'
                maxLength={255}
                disabled={readOnly}
                value={
                  values.company_branch_insurance
                    .health_insurance_uninsured_reason
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
              />
            </FormElement>
          </FormListItem>
        )}
        {insuranceStatus.healthExclusion && (
          <FormListItem
            label='適用除外理由'
            data-testid='health_insurance_reason_exclusion'
          >
            <FormElement
              info={
                values.company_branch_insurance
                  .health_insurance_reason_exclusion === 'その他' && (
                  <AdditionalInfoAboutOthers />
                )
              }
            >
              {renderHealthInsuranceReasonExclusionForm()}
            </FormElement>
          </FormListItem>
        )}
        {showHealthInsuranceType() && (
          <FormListItem label='保険種類' data-testid='health_insurance_type'>
            <FormElement
              info={
                values.company_branch_insurance.health_insurance_type ===
                  'その他' && <AdditionalInfoAboutOthers />
              }
            >
              {renderHealthInsuranceTypeFormSelect()}
            </FormElement>
          </FormListItem>
        )}
        {showHealthInsuranceNameInsurer() && (
          <FormListItem
            label='保険者名称'
            safetyDocItem={true}
            data-testid='health_insurance_name_insurer'
          >
            <FormElement>
              <TextInput
                type='text'
                name='health_insurance_name_insurer'
                maxLength={255}
                disabled={readOnly}
                value={
                  values.company_branch_insurance.health_insurance_name_insurer
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                autoComplete='off'
              />
            </FormElement>
          </FormListItem>
        )}
        {showHealthInsuranceOfficeSymbol() && (
          <FormListItem
            label='事業所整理記号'
            safetyDocItem={true}
            data-testid='health_insurance_office_symbol'
          >
            <FormElement>
              <TextInput
                type='text'
                name='health_insurance_office_symbol'
                maxLength={20}
                disabled={readOnly}
                value={
                  values.company_branch_insurance.health_insurance_office_symbol
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
              />
            </FormElement>
          </FormListItem>
        )}
        {showHealthInsuranceOfficeNumber() && (
          <FormListItem
            label='事業所番号'
            safetyDocItem={true}
            data-testid='health_insurance_office_number'
          >
            <FormElement
              validate={
                _.has(
                  messages,
                  'company_branch_insurance.health_insurance_office_number'
                ) &&
                messages.company_branch_insurance.health_insurance_office_number
              }
            >
              <TextInput
                type='text'
                name='health_insurance_office_number'
                maxLength={20}
                disabled={readOnly}
                value={
                  values.company_branch_insurance.health_insurance_office_number
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={() => events.validate('company_branch_insurance')}
              />
            </FormElement>
          </FormListItem>
        )}
        {showAttachDocumentTypeCompanyHealthInsurance() && (
          <FormListItem
            label='添付書類'
            data-testid='attach_document_type_company_health_insurance'
          >
            <FormElement>
              <AttachDocument
                requireConfirm={true}
                companyDocuments={_.filter(companyDocuments, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.HEALTH_INSURANCE
                  );
                })}
                documentCodes={_.filter(documentCodes, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.HEALTH_INSURANCE
                  );
                })}
                events={events}
                readOnly={readOnly}
                isFormListDefault
                indexId={ATTACH_DOCUMENT_TYPE_COMPANY.HEALTH_INSURANCE}
              />
            </FormElement>
          </FormListItem>
        )}
        <FormListSubHeader title='年金保険情報' />
        {!readOnly && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              お手元に年金保険の適用通知書・社会保険納入証明書・領収済証などをご用意頂きご登録頂くとスムーズです。
            </Description>
          </div>
        )}
        <FormListItem
          label='加入状況'
          safetyDocItem={true}
          data-testid='pension_flag'
        >
          <FormElement info={renderDocumentationMessage('pension_flag')}>
            <div className='form-list-radio'>
              {_.map(checkboxList.insurance_statuses, (answer, index) =>
                readOnly ? (
                  values.company_branch_insurance.pension_flag ===
                    answer.value && <span key={index}>{answer.name}</span>
                ) : (
                  <div className='form-list-radio__item' key={index}>
                    <label className='radio'>
                      <input
                        type='radio'
                        id={`form-radio-pension_flag-${answer.id}`}
                        value={answer.value}
                        name='pension_flag'
                        checked={
                          values.company_branch_insurance.pension_flag ===
                          answer.value
                        }
                        onChange={e =>
                          events.setFormValue('company_branch_insurance', e)
                        }
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>{answer.name}</span>
                    </label>
                  </div>
                )
              )}
            </div>
          </FormElement>
        </FormListItem>
        {insuranceStatus.pensionExclusion && (
          <FormListItem
            label='適用除外理由'
            data-testid='pension_reason_exclusion'
          >
            <FormElement
              info={
                values.company_branch_insurance.pension_reason_exclusion ===
                  'その他' && <AdditionalInfoAboutOthers />
              }
            >
              {renderPensionReasonExclusionFormSelect()}
            </FormElement>
          </FormListItem>
        )}
        {showPensionUninsuredReason(
          values.company_branch_insurance.pension_flag
        ) && (
          <FormListItem label='理由' data-testid='pension_uninsured_reason'>
            <FormElement>
              <TextInput
                type='text'
                name='pension_uninsured_reason'
                maxLength={255}
                disabled={readOnly}
                value={values.company_branch_insurance.pension_uninsured_reason}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
              />
            </FormElement>
          </FormListItem>
        )}
        {showPensionInsuranceType() && (
          <FormListItem label='保険種類' data-testid='pension_type'>
            <FormElement
              info={
                values.company_branch_insurance.pension_type === 'その他' && (
                  <AdditionalInfoAboutOthers />
                )
              }
            >
              {renderPensionTypeFormSelectWhenExist()}
              {/* {values.company_branch_insurance.pension_flag ===
              EXISTANCE_EXCLUSION_FLAG.EXIST.ID
                ? renderPensionTypeFormSelectWhenExist()
                : renderPensionTypeFormSelectWhenExclusion()} */}
            </FormElement>
          </FormListItem>
        )}
        {insuranceStatus.pensionPresence && (
          <FormListItem
            label='事業所整理記号'
            safetyDocItem={true}
            data-testid='pension_office_symbol'
          >
            <FormElement>
              <TextInput
                type='text'
                name='pension_office_symbol'
                maxLength={20}
                disabled={readOnly}
                value={values.company_branch_insurance.pension_office_symbol}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
              />
            </FormElement>
          </FormListItem>
        )}
        {insuranceStatus.pensionPresence && (
          <FormListItem
            label='事業所番号'
            safetyDocItem={true}
            data-testid='pension_office_number'
          >
            <FormElement
              validate={
                _.has(
                  messages,
                  'company_branch_insurance.pension_office_number'
                ) && messages.company_branch_insurance.pension_office_number
              }
            >
              <TextInput
                type='text'
                name='pension_office_number'
                maxLength={20}
                disabled={readOnly}
                value={values.company_branch_insurance.pension_office_number}
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={() => events.validate('company_branch_insurance')}
              />
            </FormElement>
          </FormListItem>
        )}
        {showAttachDocumentTypeCompanyPensionInsurance() && (
          <FormListItem
            label='添付書類'
            data-testid='attach_document_type_company_pension_insurance'
          >
            <FormElement>
              <AttachDocument
                companyDocuments={_.filter(companyDocuments, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.PENSION_INSURANCE
                  );
                })}
                documentCodes={_.filter(documentCodes, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.PENSION_INSURANCE
                  );
                })}
                events={events}
                readOnly={readOnly}
                isFormListDefault
                indexId={ATTACH_DOCUMENT_TYPE_COMPANY.PENSION_INSURANCE}
              />
            </FormElement>
          </FormListItem>
        )}
        <FormListSubHeader title='雇用保険情報' />
        {!readOnly && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              お手元に雇用保険の加入証明証・労働保険料納入通知書・領収済証などをご用意頂きご登録頂くとスムーズです。
            </Description>
          </div>
        )}
        <FormListItem
          label='加入状況'
          safetyDocItem={true}
          data-testid='employment_insurance_flag'
        >
          <FormElement
            info={renderDocumentationMessage('employment_insurance_flag')}
          >
            <div className='form-list-radio'>
              {_.map(checkboxList.insurance_statuses, (answer, index) =>
                readOnly ? (
                  values.company_branch_insurance.employment_insurance_flag ===
                    answer.value && <span key={index}>{answer.name}</span>
                ) : (
                  <div className='form-list-radio__item' key={index}>
                    <label className='radio'>
                      <input
                        type='radio'
                        id={`form-radio-employment_insurance_flag-${answer.id}`}
                        value={answer.value}
                        name='employment_insurance_flag'
                        checked={
                          values.company_branch_insurance
                            .employment_insurance_flag === answer.value
                        }
                        onChange={e =>
                          events.setFormValue('company_branch_insurance', e)
                        }
                      />
                      <RadioButtonIcon className='icon--2x' />
                      <span>{answer.name}</span>
                    </label>
                  </div>
                )
              )}
            </div>
          </FormElement>
        </FormListItem>
        {insuranceStatus.employmentExclusion && (
          <FormListItem
            label='適用除外理由'
            data-testid='employment_insurance_reason_exclusion'
          >
            <FormElement
              info={
                values.company_branch_insurance
                  .employment_insurance_reason_exclusion === 'その他' && (
                  <AdditionalInfoAboutOthers />
                )
              }
            >
              {renderEmploymentInsuranceReasonExclusionFormSelect()}
            </FormElement>
          </FormListItem>
        )}
        {showEmploymentInsuranceUninsuredReason(
          values.company_branch_insurance.employment_insurance_flag
        ) && (
          <FormListItem
            label='理由'
            data-testid='employment_insurance_uninsured_reason'
          >
            <FormElement>
              <TextInput
                type='text'
                name='employment_insurance_uninsured_reason'
                maxLength={255}
                disabled={readOnly}
                value={
                  values.company_branch_insurance
                    .employment_insurance_uninsured_reason
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
              />
            </FormElement>
          </FormListItem>
        )}
        {insuranceStatus.employmentPresence && (
          <FormListItem
            label='労働保険番号'
            safetyDocItem={true}
            data-testid='employment_insurance_insurance_number'
          >
            <FormElement
              validate={
                _.has(
                  messages,
                  'company_branch_insurance.employment_insurance_insurance_number'
                ) &&
                messages.company_branch_insurance
                  .employment_insurance_insurance_number
              }
            >
              <TextInput
                type='text'
                name='employment_insurance_insurance_number'
                maxLength={20}
                disabled={readOnly}
                value={
                  values.company_branch_insurance
                    .employment_insurance_insurance_number
                }
                onChange={e =>
                  events.setFormValue('company_branch_insurance', e)
                }
                onBlur={() => events.validate('company_branch_insurance')}
              />
            </FormElement>
          </FormListItem>
        )}
        {showAttachDocumentTypeCompanyEmploymentInsurance() && (
          <FormListItem
            label='添付書類'
            data-testid='attach_document_type_company_employment_insurance'
          >
            <FormElement>
              <AttachDocument
                companyDocuments={_.filter(companyDocuments, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.EMPLOYMENT_INSURANCE
                  );
                })}
                documentCodes={_.filter(documentCodes, document => {
                  return (
                    document.file_typeL ===
                    ATTACH_DOCUMENT_TYPE_COMPANY.EMPLOYMENT_INSURANCE
                  );
                })}
                events={events}
                readOnly={readOnly}
                isFormListDefault
                indexId={ATTACH_DOCUMENT_TYPE_COMPANY.EMPLOYMENT_INSURANCE}
              />
            </FormElement>
          </FormListItem>
        )}
        {!readOnly && (
          <div className='form-list__qr-message'>
            ※QRコードは(株)デンソーウェーブの登録商標です。
          </div>
        )}
      </FormList>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/PartnerCompanyBranchSafetyForm.jsx